var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('img',{attrs:{"alt":"EDR logo","src":require("../assets/icon-192x192.png"),"width":"192","height":"192"}}),_c('LandingPage',{attrs:{"msg":"ED Recon"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }